module.exports = __webpack_public_path__ + "07987ad29920fa2fb2b3748c52f32840.fbx";